import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { L as ListHeaderText } from "./ListHeaderText.js";
import { useBreakpoint, Breakpoint } from "./hooks/useBreakpoint.js";
import { isComponent, isComponentWithChildren } from "./utils/component.js";
import { a as AvatarSize, A as Avatar } from "./Avatar.js";
import { B as Badge } from "./Badge.js";
import { I as Icon } from "./Icon.js";
import { IconSize } from "./constants.js";
import styles from "./components/ListHeader/styles.module.scss";
const renderListHeader = (element, titleHtmlMarkup, isHovered, size, chevronIcon, icon) => {
  if (isComponent(element, ListHeader)) {
    return React__default.cloneElement(element, {
      chevronIcon,
      icon,
      isHovered,
      size
    });
  }
  if (element) {
    return /* @__PURE__ */ jsx(ListHeader, { titleHtmlMarkup, chevronIcon, icon, isHovered, size, children: element });
  }
};
const mapChildren = (children, isJsxChild = false) => {
  var _a, _b, _c, _d;
  let avatarChild;
  const badgeChildren = [];
  const listHeaderTextChildren = [];
  const stringChildren = [];
  const remainingChildren = [];
  React__default.Children.forEach(children, (child) => {
    if (child === null || typeof child === "undefined") return;
    if (isComponent(child, Avatar)) {
      avatarChild = child;
    } else if (isComponent(child, ListHeaderText)) {
      listHeaderTextChildren.push(child);
    } else if (isComponent(child, Badge)) {
      badgeChildren.push(child);
    } else if (typeof child === "string") {
      stringChildren.push(child);
    } else {
      remainingChildren.push(child);
    }
  });
  const hasSpecialChildren = avatarChild !== void 0 || listHeaderTextChildren.length > 0 || badgeChildren !== void 0 && stringChildren.length > 0;
  const noRemainingRecursiveChildren = remainingChildren.length === 0 || isComponentWithChildren(remainingChildren[0]) && typeof ((_b = (_a = remainingChildren[0]) == null ? void 0 : _a.props) == null ? void 0 : _b.children) === "undefined";
  if (isJsxChild || hasSpecialChildren || noRemainingRecursiveChildren) {
    return { avatarChild, listHeaderTextChildren, badgeChildren, stringChildren, remainingChildren };
  }
  if (isComponentWithChildren(remainingChildren[0])) {
    return mapChildren((_d = (_c = remainingChildren[0]) == null ? void 0 : _c.props) == null ? void 0 : _d.children, true);
  }
};
const ListHeader = (props) => {
  const { className = "", titleHtmlMarkup = "h2", chevronIcon, children, icon, isHovered, size, testId } = props;
  const breakpoint = useBreakpoint();
  const showIcon = size !== "small" && !!icon;
  const contentIsString = typeof children === "string";
  const mappedChildren = mapChildren(children);
  const listLabelClasses = classNames(styles["list-header"], className);
  const badgeContainerClasses = classNames(styles["list-header__badge-container"]);
  const badgeClasses = classNames(styles["list-header__badge"]);
  const chevronClasses = classNames(styles["list-header__chevron"]);
  const contentClasses = classNames(styles["list-header__content"], {
    [styles["list-header__content--element"]]: !contentIsString
  });
  const iconClasses = classNames(styles["list-header__icon"], {});
  const avatarClasses = classNames(styles["list-header__avatar"], {});
  const CustomTag = titleHtmlMarkup;
  return /* @__PURE__ */ jsxs("span", { "data-testid": testId, className: listLabelClasses, children: [
    showIcon && icon && /* @__PURE__ */ jsx("span", { className: iconClasses, children: React__default.cloneElement(icon, {
      size: breakpoint === Breakpoint.xs ? IconSize.XSmall : IconSize.Small,
      isHovered
    }) }),
    size !== "small" && (mappedChildren == null ? void 0 : mappedChildren.avatarChild) && /* @__PURE__ */ jsx("span", { className: avatarClasses, children: React__default.cloneElement(mappedChildren.avatarChild, { size: AvatarSize.xsmall }) }),
    /* @__PURE__ */ jsxs("span", { className: contentClasses, children: [
      mappedChildren == null ? void 0 : mappedChildren.listHeaderTextChildren,
      !!(mappedChildren == null ? void 0 : mappedChildren.stringChildren.length) && /* @__PURE__ */ jsx(CustomTag, { className: styles["list-header__title"], children: mappedChildren.stringChildren }),
      mappedChildren == null ? void 0 : mappedChildren.remainingChildren
    ] }),
    /* @__PURE__ */ jsx("span", { className: badgeContainerClasses, children: (mappedChildren == null ? void 0 : mappedChildren.badgeChildren) && mappedChildren.badgeChildren.map((badgeChild, index) => {
      return /* @__PURE__ */ jsx("span", { className: badgeClasses, children: badgeChild }, index);
    }) }),
    chevronIcon && /* @__PURE__ */ jsx("span", { className: chevronClasses, children: /* @__PURE__ */ jsx(Icon, { svgIcon: chevronIcon, isHovered, size: IconSize.XSmall }) })
  ] });
};
ListHeader.displayName = "ListHeader";
export {
  ListHeader as L,
  mapChildren as m,
  renderListHeader as r
};
//# sourceMappingURL=ListHeader.js.map
